export interface AdminFeatureRouteRule {
  featureKey: string;
  patterns: string[];
}

export const ADMIN_FEATURE_ROUTE_RULES: AdminFeatureRouteRule[] = [
  { featureKey: "admin.dashboard", patterns: ["/portal/dashboard"] },
  {
    featureKey: "user.edit",
    patterns: [
      "/portal/clients",
      "/portal/clientuser*",
      "/portal/clientbalanceoverview*",
      "/portal/clientbankaccounts*",
      "/portal/client-usd-bankaccounts*",
      "/portal/client-withdrawall-addresses*",
      "/portal/client-api-keys*",
      "/portal/organisations*",
      "/portal/businesses*",
      "/portal/pin-reset-requests*",
      "/portal/manage-tickets*",
      "/portal/manage-faqs*",
    ],
  },
  {
    featureKey: "compliance.review",
    patterns: ["/portal/verif-clients*", "/portal/compliance*"],
  },
  {
    featureKey: "admin.finance.view",
    patterns: [
      "/portal/PaymentTransaction*",
      "/portal/autostack-purchases*",
      "/portal/user-autostacks*",
      "/portal/deposits*",
      "/portal/withdrawals*",
      "/portal/crypto-deposits*",
      "/portal/crypto-withdrawals*",
      "/portal/deposit-logs*",
      "/portal/withdrawal-logs*",
      "/portal/arbitrage-batches*",
      "/portal/liquidity-pool*",
      "/portal/lp-history*",
      "/portal/lp-alert*",
      "/portal/trading-fees*",
      "/portal/transaction-history*",
      "/portal/custom-orders*",
      "/portal/deferred-settlements*",
      "/portal/broker-applications*",
      "/portal/broker-overview*",
      "/portal/broker-trades*",
      "/portal/broker-commissions*",
      "/portal/manage-investments*",
      "/portal/subscription-approval*",
      "/portal/user-summary*",
      "/portal/payouts*",
      "/portal/zar8-conversions*",
      "/portal/zar8-reserves*",
      "/portal/zar8-rewards*",
      "/portal/zar8-yield-positions*",
      "/portal/zar8-yield-distributions*",
      "/portal/zar8-yield-configuration*",
    ],
  },
  {
    featureKey: "asset.flag.flip",
    patterns: [
      "/portal/trading-assets*",
      "/portal/asset-order*",
      "/portal/tradable-pairs*",
      "/portal/tradeble-pairs*",
      "/portal/ncw-supported-assets*",
      "/portal/ncw-supported-blockchain*",
      "/portal/chooseAsset*",
    ],
  },
  {
    featureKey: "system.settings",
    patterns: [
      "/portal/all-news*",
      "/portal/notifications*",
      "/portal/emails*",
      "/portal/settings-system*",
      "/portal/settings-contact*",
      "/portal/settings-api-keys*",
      "/portal/banks*",
      "/portal/policies*",
      "/portal/2fa*",
      "/portal/settings*",
    ],
  },
  {
    featureKey: "audit.view",
    patterns: ["/portal/audit-logs*", "/portal/login-history*"],
  },
  { featureKey: "role.grant", patterns: ["/portal/access-control*"] },
];

const patternMatchesPath = (pattern: string, pathname: string): boolean => {
  if (pattern.endsWith("*")) {
    const prefix = pattern.slice(0, -1);
    return pathname === prefix || pathname.startsWith(prefix);
  }

  if (pattern.includes(":")) {
    const escapedPattern = pattern
      .split("/")
      .map((segment) => {
        if (segment.startsWith(":")) {
          return "[^/]+";
        }

        return segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      })
      .join("/");

    return new RegExp(`^${escapedPattern}$`).test(pathname);
  }

  return pathname === pattern;
};

export const getRequiredAdminFeatureForPath = (
  pathname: string
): string | null => {
  for (const rule of ADMIN_FEATURE_ROUTE_RULES) {
    if (
      rule.patterns.some((pattern) => patternMatchesPath(pattern, pathname))
    ) {
      return rule.featureKey;
    }
  }

  return null;
};
